import { store } from '@/app/store'
import { setOrderServiceFeePercentage, setOrderTaxPercentage } from '@/features/settings/settingsSlice'
import { fetchOrderServiceFeePercentage, fetchOrderTaxPercentage } from '@/services/settingsService'

// Fire-and-forget: reuse Settings fetch; never block startup.
void fetchOrderTaxPercentage().then((percentage) => {
  store.dispatch(setOrderTaxPercentage(percentage))
})
void fetchOrderServiceFeePercentage().then((percentage) => {
  store.dispatch(setOrderServiceFeePercentage(percentage))
})
